import Vue from 'vue'
import Loading from './Loading.vue'

let LoadingConstructor
let loadingDom
try {
  // 返回一个 扩展实例构造器
  LoadingConstructor = Vue.extend(Loading)
  // 实例化
  loadingDom = new LoadingConstructor({
    el: document.createElement('div'),
  })

  // 把 实例化的 Loading.vue 添加到 body 里
  document.body.appendChild(loadingDom.$el)
} catch (e) {
  console.error(e)
}


// 注册为全局组件的函数
function registryLoading() {
  // 将组件注册到 vue 的 原型链里去,
  // 这样就可以在所有 vue 的实例里面使用 this.$loading.show()
  Vue.prototype.$loading = {
    show() {
      loadingDom.isShow = true
    },
    hide(){ 
      loadingDom.isShow = false
    }
  }
}

export default registryLoading